import { MultiLingualObj } from '@app/components/common/Table/DefaultTable/types';

export const DEFAULT_LANGUAGE = 'en';

export const languages = [
  {
    id: 1,
    key: 'en',
    label: 'English',
    img: 'https://upload.wikimedia.org/wikipedia/en/thumb/a/ae/Flag_of_the_United_Kingdom.svg/1200px-Flag_of_the_United_Kingdom.svg.png',
  },
  // {
  //   id: 2,
  //   key: 'ar',
  //   label: 'Arabic',
  //   img: 'https://upload.wikimedia.org/wikipedia/commons/0/03/Flag_of_Saudi_Arabia_%28type_1%29.svg',
  // },
];

export const getFieldOnMainLanguage = (field: unknown) => {
  return field && typeof field === 'object' && (field as MultiLingualObj)[DEFAULT_LANGUAGE]
    ? (field as MultiLingualObj)[DEFAULT_LANGUAGE]
    : '';
};
